import { getDateTime } from './getDateTime'
import { parseToDate } from './parseToDate'
import { InputDate } from './types/inputDate'

export const getFormattedDateTimeParts = (
  date?: InputDate,
  locale?: string,
  options?: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormatPart[] => getDateTime(locale, options).formatToParts(parseToDate(date))
